import styled from "styled-components/macro";

const Placeholder = styled.div`
  padding: 16px;
  min-height: 92px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme["@grey-darker"]};
`;

export default Placeholder;
